import { createAction, createSlice } from '@reduxjs/toolkit';
import { AdminModal } from 'register/AdminModal';
import { AdminModalKey, AdminModalParamsMapping } from 'register/AdminModalParams';

import { ModalState, STORE_NAME } from './initialState';

// Modal has bad architecture, to support TS check generic action have to be passed in this way otherwise slice will not see it.

type OpenModalPayload<N extends AdminModal> = {
  name: AdminModalKey<N>;
  params: AdminModalParamsMapping[N];
};
const openModalAction = createAction<OpenModalPayload<AdminModal>>(`${STORE_NAME}/openModal`);

export const openModal = <N extends AdminModal>(payload: OpenModalPayload<N>) =>
  openModalAction(payload);

type UpdateModalPayload<N extends AdminModal> = OpenModalPayload<N> & { pending?: boolean };
const updateModalAction = createAction<UpdateModalPayload<AdminModal>>(`${STORE_NAME}/updateModal`);

export const updateModal = <N extends AdminModal>(payload: UpdateModalPayload<N>) =>
  updateModalAction(payload);

export const modalSlice = createSlice({
  name: STORE_NAME,
  initialState: ModalState.INITIAL_DOMAIN,
  reducers: {
    closeModal: () => ModalState.INITIAL_DOMAIN,
  },
  extraReducers: (builder) => {
    builder
      .addCase(openModalAction, (state, action) => {
        state.name = action.payload.name;
        state.params = action.payload.params;
        state.pending = false;
      })
      .addCase(updateModalAction, (state, action) => {
        if (state.name === action.payload.name) {
          state.params = action.payload.params;
          state.pending = !!action.payload.pending;
        }
      });
  },
});

export const { closeModal } = modalSlice.actions;
